import AutomationActionBlockPanel from "@components/automations/panels/AutomationActionBlockPanel";
import AutomationConditionBlockPanel from "@components/automations/panels/AutomationConditionBlockPanel";
import AutomationStatsPanel from "@components/automations/panels/AutomationStatsPanel";
import AutomationTerminatorBlockPanel from "@components/automations/panels/AutomationTerminatorBlockPanel";
import AutomationTimingBlockPanel from "@components/automations/panels/AutomationTimingBlockPanel";
import AutomationTriggerBlockPanel from "@components/automations/panels/AutomationTriggerBlockPanel";
import { Selection } from "@typing/Automations";
import { AutomationFragment as AutomationType } from "@typing/Generated";

type Block = NonNullable<AutomationType["blocks"][number]>;

type Props = {
  automation: AutomationType;
  onBlockAdded: (block: Block) => void;
  selection: Selection;
};

const AutomationPanel = ({ automation, onBlockAdded, selection }: Props) => {
  if (selection?.block) {
    if (selection.block.__typename === "AutomationActionBlock") {
      const automationActionBlock = selection.block;
      return (
        <AutomationActionBlockPanel
          automation={automation}
          automationActionBlock={automationActionBlock}
          onBlockAdded={onBlockAdded}
        />
      );
    }
    if (selection.block.__typename === "AutomationConditionBlock") {
      const automationConditionBlock = selection.block;
      return (
        <AutomationConditionBlockPanel
          automation={automation}
          automationConditionBlock={automationConditionBlock}
          onBlockAdded={onBlockAdded}
        />
      );
    }
    if (selection.block.__typename === "AutomationTimingBlock") {
      const automationTimingBlock = selection.block;
      return (
        <AutomationTimingBlockPanel
          automation={automation}
          automationTimingBlock={automationTimingBlock}
          onBlockAdded={onBlockAdded}
        />
      );
    }
    if (selection.block.__typename === "AutomationTriggerBlock") {
      const automationTriggerBlock = selection.block;
      return <AutomationTriggerBlockPanel automationTriggerBlock={automationTriggerBlock} locked={automation.locked} />;
    }
  } else if (selection?.terminator) {
    return <AutomationTerminatorBlockPanel automation={automation} onBlockAdded={onBlockAdded} selection={selection} />;
  }

  return <AutomationStatsPanel automation={automation} />;
};

export default AutomationPanel;
